import React, { useState, useRef, useCallback } from 'react';
import './Header.css';
import logo from '../../assets/images/logo/logo.svg';
import dropdownArrow from '../../assets/icons/dropdown-arrow.svg';
import dropdownArrowHover from '../../assets/icons/dropdown-arrow_hover.svg';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Box } from '../common/Box/Box';

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [isHovered, setIsHovered] = useState(false);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const logoClickCountRef = useRef(0); 
  const logoClickTimeoutRef = useRef(null);
  const dropdownTimeoutRef = useRef(null);
  const dropdownRef = useRef(null);

  const handleLogoClick = useCallback(() => {
    logoClickCountRef.current += 1;
    
    if (logoClickTimeoutRef.current) {
      clearTimeout(logoClickTimeoutRef.current);
    }
    
    logoClickTimeoutRef.current = setTimeout(() => {
      logoClickCountRef.current = 0;
    }, 2000);
    
    if (logoClickCountRef.current === 3) {
      logoClickCountRef.current = 0;
      navigate('/admin/login');
    }
  }, [navigate]);

  const handleMouseEnter = () => {
    setIsHovered(true);
    clearTimeout(dropdownTimeoutRef.current);
    setIsDropdownOpen(true);
  };

  const handleMouseLeave = () => {
    setIsHovered(false);
    dropdownTimeoutRef.current = setTimeout(() => {
      setIsDropdownOpen(false);
    }, 200);
  };

  const handleMenuMouseEnter = () => {
    clearTimeout(dropdownTimeoutRef.current);
  };

  const handleMenuMouseLeave = () => {
    handleMouseLeave();
  };

  return (
    <header className="header">
      <div className="header-container">
        <div className="logo" onClick={handleLogoClick} style={{ cursor: 'pointer' }}>
          <img src={logo} alt="Family Park Logo" className="logo-image" />
        </div>
        
        <nav className="navigation">
          <Link
            to="/"
            className={`nav-link ${location.pathname === '/' ? 'active' : ''}`}
          >
            Главная
          </Link>
          
          <Link
            to="/about"
            className={`nav-link ${location.pathname === '/about' ? 'active' : ''}`}
          >
            О парке
          </Link>
          
          <div
            className="dropdown-container"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseLeave}
            ref={dropdownRef}
          >
            <div className="nav-link dropdown">
              Развлечения
              <img 
                src={isHovered ? dropdownArrowHover : dropdownArrow} 
                alt="▼" 
                className="dropdown-arrow" 
              />
            </div>
            
            {isDropdownOpen && (
              <div
                className="dropdown-menu-wrapper"
                onMouseEnter={handleMenuMouseEnter}
                onMouseLeave={handleMenuMouseLeave}
              >
                <Box />
              </div>
            )}
          </div>
          
          <Link
            to="/news"
            className={`nav-link ${location.pathname === '/news' ? 'active' : ''}`}
          >
            Новости
          </Link>
        </nav>
      </div>
    </header>
  );
};

export default Header;